import { getDeregistrationApi } from 'api/article'
import errorHandler from 'utils/errorHandler'

export default payload => async (dispatch) => {
  try {
    return await getDeregistrationApi(payload)
  } catch (error) {
    return errorHandler(error)
  }
}
